module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-aure.11666293.jpg";